function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7,
  y1: 2,
  x2: 29,
  y2: 2,
  stroke: "#1F79FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  fill: "#1F79FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7,
  y1: 8,
  x2: 29,
  y2: 8,
  stroke: "#1F79FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 2,
  fill: "#1F79FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7,
  y1: 14,
  x2: 29,
  y2: 14,
  stroke: "#1F79FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2,
  cy: 14,
  r: 2,
  fill: "#1F79FF"
});

var SvgViewAll = function SvgViewAll(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgViewAll, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view-all.3afbf097.svg";
export { ForwardRef as ReactComponent };